import apiUrl from '../../../constants'
import axios from 'axios'
//import Paginate from 'vuejs-paginate'
import CryptoJS from 'crypto-js';
import {
	Validator
} from 'vee-validate'
import Loader from './../shared/loader'
import Pagination from './../shared/pagination'
export default {
	name: 'client',
	components: {
		Pagination,
		//  Paginate,
		Loader
	},
	data: function() {
		return {
			currentPage: 1,
			totalPage: 0,
			totalCount: 0,
			pageLimit: 10,
			showSelectWarehouse: false,

			//currentPage: 0,
			modalShow: false,
			editBinmodal: false,
			addBinmodal: false,
			addmodalshow: false,
			status: '',
			binaction: '',
			listBinData: [],
			listMaxCountdata: [],
			WarehouseErr: '',
			// pageno: 0,
			// pagecount: 0,
			showSelectClient: false,
			isLoading: false,
			is_Loading: false,
			resultCount: '',
			editBinname: '',
			binname: '',
			quantity: '',
			BinSequence: '',
			Prefix: '',
			PostFix: '',
			warehousesearch: '',
			warehouseid:'',
			warehousename: '',
			listWarehouseData: [],
			qtyerror: false,
		}
	},
	created: function() {},
	// when a page loads,mounted() will be call
	mounted() {
		this.pageno = 0
		// this.getClientList()
		// this.getBinData()
		var userdetailEncrypt = window.localStorage.getItem('userdetail')
		var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext);
		this.useremail = userdetail.email;
		// var temp = this.useremail.split('/');
		this.warehouseid=window.localStorage.getItem('selectedWarehouse')

		this.user_type = userdetail.utype;

		switch (this.user_type) {
			case 'system_user':
				this.showSelectWarehouse = true;
				// this.getClientList();
				// this.getWarehouseList();
				break;

			case 'client_user':
				this.clientid = userdetail.clientid;
				// this.getWarehouseList();
				this.showSelectWarehouse = true;
				break;

			case 'warehouse_user':
				this.loginUserEmail = userdetail.email;
				this.warehouseid = userdetail.warehouseid;
				this.showSelectWarehouse = false;
				this.getBinData();

				var roleids = userdetail.roleid.split(',');
				for (var i = 0; i < roleids.length; i++) {
					if (roleids[i] == 40) {
						this.purchasingManager = parseInt(roleids[i]);
					}
					if (roleids[i] == 41) {
						this.isInwardUserForPO = true;
					}
				}
				break;

			default:
				this.$alertify.error("Unauthorised user, Please contact your system admin");
				break
		}
	},
	methods: {
		checkinput() {
			if (this.quantity <= 0 && this.quantity != '') {
				this.qtyerror = true;
			} else {
				this.qtyerror = false;;

			}
		},
		// getWarehouseList() {
		// 	this.pageno = 0;
		// 	if (window.localStorage.getItem("warehouseList") !== null) {
		// 		var warehouseListEncrypt = window.localStorage.getItem('warehouseList');
		// 		var warehousebytes = CryptoJS.AES.decrypt(warehouseListEncrypt.toString(), 'Key');
		// 		var plaintextwarehouse = warehousebytes.toString(CryptoJS.enc.Utf8);
		// 		this.listWarehouseData = JSON.parse(plaintextwarehouse);
		// 	} else {

		// 		var userToken = window.localStorage.getItem('userToken')
		// 		var myStr = userToken.replace(/"/g, '');

		// 		this.input = ({
		// 			'clientid': this.clientid,
		// 		});

		// 		axios({
		// 				method: 'POST',
		// 				'url': apiUrl.api_url + 'getClientAssociatedWarehouseList',
		// 				'data': this.input,
		// 				headers: {
		// 					'Authorization': 'Bearer ' + myStr
		// 				}
		// 			})
		// 			.then(result => {
		// 				this.listWarehouseData = result.data.data;
		// 			}, error => {
		// 				console.error(error)
		// 			})
		// 	}
		// },
		//open new form(popup)
		addNewClient() {
			this.binaction = 'add'
			this.addBinmodal = true
			this.binname = '';
			this.quantity = '';
			this.BinSequence = '';
			this.Prefix = '';
			this.PostFix = '';
			//to clear error messages(validation messages)
			this.$validator.reset();
			this.errors.clear();
		},
		// to open add modal
		addmodalShow() {
			this.Statusaction = 'add'
			this.addmodalShow = true
		},
		//to close active/inactive modal
		closeaddmodalShow() {
			this.addmodalShow = false
		},
		//to close new form
		closeaddBinmodal() {
			this.addBinmodal = false
		},
		//to close edit form
		closeeditBinModal() {
			this.addBinmodal = false
		},
		getBinSearch() {
			this.currentPage = 1;
			this.getBinData();
		},

		//to get bin list
		getBinData() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			if (window.localStorage.getItem('selectedWarehouse')==='undefined') {
				this.$alertify.error(this.$t('common.warehouseError'))
				this.pageno = this.pageCount = 0;
				this.listBinData = [];
				return false;
			}
			if (this.showSelectWarehouse == true) {
				this.warehouseid = this.warehousesearch
			}

			this.input = ({
				offset: (this.currentPage - 1) * 10,
				limit: 10,
				binid: this.binname.trim(),
				warehouseid: window.localStorage.getItem('selectedWarehouse'),
			})
			this.isLoading = true;
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'getbinlist',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then(result => {
					this.listBinData = result.data.data
					this.isLoading = false;

					this.totalCount = result.data.count
					this.resultCount = result.data.count;
					if (this.totalCount < 10) {
						this.totalPage = 1
					} else {
						this.totalPage = Math.ceil(this.totalCount / 10);
					}
				}, error => {
					console.error(error)
				})
		},
		// save form fields in mysql database
		saveBin() {

			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');

			if (this.showSelectWarehouse == true) {
				this.warehouseid = this.warehousename
			}
			if (this.qtyerror == true) {
				return false;
			}
			this.is_Loading = true
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'saveBinData',
					'data': {
						'warehouseid': window.localStorage.getItem('selectedWarehouse'),
						'quantity': this.quantity,
						'Prefix': this.Prefix,
						'PostFix': this.PostFix,
						'createdby': this.useremail

					},
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then((response) => {
					if (response.data.errorCode == 0) {
						this.is_Loading = false
						this.$alertify.success(response.data.msg)
						this.addBinmodal = false;
						this.resetaddDeatilsForm();
						this.getBinData();

					} else if (response.data.errorCode == -1) {
						this.is_Loading = false
						this.$alertify.error(response.data.msg)
						this.resetaddDeatilsForm();
						this.addBinmodal = true
					}
				})
				.catch((httpException) => {
					console.error('exception is:::::::::', httpException)
				})
		},
		getStatusRowData(data) {
			this.modalShow = true
			this.id = data.id
			this.status = data.status
			if (this.status.trim() == 'active' || this.status.trim() == 'Active') {
				this.changestatus = 'De-Activate'
			} else {
				this.changestatus = 'Activate'
			}
		},
		changeTOTStatus() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');

			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'updateConsoBINStatus',
					'data': {
						'id': this.id,
						'status': this.status.trim(),
					},
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then((response) => {
					if (response.data.msg > 0) {
						this.$alertify.success("BIN Status update Successfully")
						this.addmodalShow = false
						this.getTOTlist();
					}
				})
				.catch((httpException) => {
					console.error('exception is:::::::::', httpException)
				})
		},



		resetForm() {
			this.binname = '';
			this.warehousesearch = '';
			this.resultCount = 0;
			this.listBinData = [];
		},
		resetaddDeatilsForm() {
			this.binname = '';
			this.warehousename = '';
			this.quantity = '';
			this.BinSequence = '';
			this.Prefix = '';
			this.PostFix = '';
			this.addBinmodal = false;

		},

		//change status of modal
		closeStatusBinModal() {
			this.modalShow = false
		},

		onPageChange(page) {
			this.currentPage = page;
			this.getBinData()
		},
		//validate all form fields on onsubmit()
		onSubmit() {
			this.$validator.validateAll().then((result) => {
				if (!result) {
					console.log('form is invalid', this.model)
					return false;
				} else {
					console.log('form is valid', this.model)
					this.saveBin();
					// this.validateformat()
				}

			}).catch(() => {
				console.log('errors exist', this.errors)
			});
		},

	}
}



// WEBPACK FOOTER //
// ./src/views/components/binmaster/binmaster.component.js